import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-licensing',
    templateUrl: './licensing.component.html',
    styleUrls: ['./licensing.component.scss']
})
export class LicensingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
